var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.info)?_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-icon',_vm._g(_vm._b({attrs:{"color":"rgba(0, 0, 0, 0.87)"}},'v-icon',attrs,false),on),[_vm._v("mdi-information-outline")])]}}],null,false,4206805010)},[_c('span',[_vm._v(_vm._s(_vm.info))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }